import { http } from '../../config/axios'

export default function getOpcoesConsultaAgrupada(): Promise<any[]> {
  return http
    .get('api/permissao/opcoesconsultaagrupadas')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getOpcoesConsulta', error)
      throw Error(error.response.data)
    })
}
